import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useRouter } from '../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';

//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { Box, Button, FormField, Input, Link, List, Modal, Pagination, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiAlert, mdiAllInclusiveBoxOutline, mdiCalendarRange, mdiClockOutline, mdiMovieOpenOutline, mdiReload, mdiTelevision } from '@mdi/js';
import Icon from '@mdi/react';
import { parse } from 'date-fns';
import BadgeCustom from '../../../../components/extras/BadgeCustom';
import Favorites from '../../../../components/extras/Favorites';
import SelectPaging from '../../../../components/selects/selectPaging';
import { VideoPreview } from '../../../../components/videos/VideoPreview';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { weekDays } from '../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../commons/functions';
interface Config {
    direction?: string;
    module?: string;
    type?: string;
    statusesIds?: number[];
    file?: string; // <--- Add this line
}
export const MarketingProgramsPage = () => {
    //const storeAdmin = useStoreAdmin();
    const [programs, setPrograms] = useState<any[]>([])
    const [media, setMedia] = useState<any>(null)
    const [display, setDisplay] = useState<any>(null)

    const { navigate } = useRouter();
    const { parameters, menu, data, idAirport } = useGlobalState();
    const [medias, setMedias] = useState<any[]>([])
    const [videoUrl, setVideoUrl] = useState<string>("");


    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filterValue, setFilterValue] = useState("");
    const filtered = useMemo(() => {

        if (!programs) return [];
        if (!programs.length) return [];
        if (filterValue.trim().length < 2) return programs;
        setCurrentPageIndex(1);
        const searchWords = filterValue.toLowerCase().trim().split(/\s+/);
        return programs.filter((item: any) => {
            const searchableText = `${item.idMedia} ${item.name || ''} ${item.fileName || ''} ${item.jsonSchedule.startDate || ''} ${item.jsonSchedule.endDate || ''} ${item.jsonSchedule.startTime || ''} ${item.jsonSchedule.endTime || ''} ${item.program || ''}`.toLowerCase();
            return searchWords.every(word => searchableText.includes(word));
        });
    }, [programs, filterValue]);
    const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);


    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        const timer = setTimeout(() => {
            handleGetPrograms();
        }, 500);
        return () => clearTimeout(timer);
    }, [idAirport]);
    const handleGetPrograms = async () => { // Make the function async

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'JWT': getCookie("JWT"),
                    'x-routing': '/private/marketing/programs/list',
                },
                body: JSON.stringify({
                    orderBy: "idMedia",
                    order: "DESC"
                }),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {

                if (dataWeb.displays) {
                    setData((prevData: any) => ({
                        ...prevData,
                        displays: dataWeb.displays
                    }));
                }
                if (dataWeb.programs) {
                    const airportTime = parse(dataWeb.dateAirport, "dd-MM-yyyy", new Date());

                    const dataMap = dataWeb.programs.map((program: any) => {
                        return {
                            ...program,
                            hasEnded: program.jsonSchedule.endDate === ""
                                || parse(program.jsonSchedule.endDate, "dd-MM-yyyy", new Date()) > airportTime
                                ? 0 : 1,
                            hasStarted: program.jsonSchedule.startDate === ""
                                || parse(program.jsonSchedule.startDate, "dd-MM-yyyy", new Date()) < airportTime
                                ? 1 : 0,
                        };

                    });
                    setPrograms(dataWeb.programs);
                    setCurrentPageIndex(1);
                } else {
                    setPrograms([]);
                }
                console.log(dataWeb.medias)
                if (dataWeb.medias) {
                    setMedias(dataWeb.medias);
                } else {
                    setMedias([]);
                }
            } else {
                addNotification(dataWeb.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        if (parameters.date !== "") {
            handleGetPrograms();
        }

    }, [parameters.date]);
    useEffect(() => {

    }, []);

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Programación de publicidades {`(${filtered.length}/${programs.length})`}</Header>
                    <Table

                        pagination={

                            <SpaceBetween direction="horizontal" size="xs" alignItems="center">

                                {filtered.length > parameters.pageSize && (
                                    <Pagination
                                        currentPageIndex={currentPageIndex}
                                        pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                                        onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                    />
                                )}

                                {filtered.length > parameters.pageSize && (

                                    <SelectPaging onSelect={(pageSize) => {
                                        setCurrentPageIndex(1);
                                        setParameters({ ...parameters, pageSize: pageSize });
                                    }} />
                                )}
                            </SpaceBetween>
                        }
                        variant='embedded'
                        stickyHeader
                        filter={
                            <SpaceBetween direction="horizontal" size="xs">
                                <FormField label="Palabra(s) clave(s)">
                                    <Input value={filterValue} placeholder="Buscar programas" onChange={e => setFilterValue(e.detail.value)}

                                    />
                                </FormField>
                                <FormField label="&nbsp;">
                                    <Button variant="primary" onClick={() => {
                                        handleGetPrograms();
                                    }}><Icon path={mdiReload} size={1} /></Button>
                                </FormField>
                            </SpaceBetween>
                        }
                        items={paginated ?? []}
                        columnDefinitions={[
                            {
                                id: "id",
                                cell: (e: any) => <Link href={`#marketing/program.edit?id=${e?.idMedia}`}>{e?.idMedia} {e.isActive === 1 ? "" : "(Inactivo)"}</Link>,
                                header: "ID",
                                width: 100
                            },
                            {
                                id: "description",
                                cell: (e: any) => {
                                    // Safety check to ensure the array exists
                                    const scheduledDays = e?.jsonSchedule?.weekDays.filter((day: any) => day !== 0) || [];
                                    return (
                                        <FormField label={e?.program || "Sin nombre"}>
                                            <div style={{ display: 'flex', gap: '2px' }}>
                                                {weekDays.filter((day: any) => day.weekDay !== 0).map((day) => {
                                                    const isActive = scheduledDays.includes(day.weekDay);
                                                    return (
                                                        <span
                                                            key={day.weekDay}
                                                            style={{
                                                                color: isActive ? 'black' : '#bbb',
                                                                fontWeight: isActive ? 'bold' : 'bold',
                                                                fontSize: '0.85rem'
                                                            }}
                                                        >
                                                            {day.short}
                                                        </span>
                                                    );
                                                })}
                                            </div>
                                        </FormField>
                                    );
                                },
                                header: "Glosa"
                            },
                            {
                                id: "Inicio",
                                cell: (e: any) => <>{e?.jsonSchedule?.startDate !== "" ? e?.jsonSchedule?.startDate : <Icon path={mdiAllInclusiveBoxOutline} size={1} />}</>,
                                header: <><Icon path={mdiCalendarRange} size={1} />Inicio</>,
                                width: 100
                            },
                            {
                                id: "Término",
                                cell: (e: any) => <>{e?.jsonSchedule?.endDate !== "" ? e?.jsonSchedule?.endDate : <Icon path={mdiAllInclusiveBoxOutline} size={1} />} {e?.hasEnded && e?.hasEnded !== "" ? <Icon path={mdiAlert} size={1} color="orange" /> : ""}</>,
                                header: <><Icon path={mdiCalendarRange} size={1} />Término</>,
                                width: 100
                            },
                            {
                                id: "startTime",
                                cell: (e: any) => <>{e?.jsonSchedule?.startTime !== "" ? e?.jsonSchedule?.startTime : "00:00"}</>,
                                header: <><Icon path={mdiClockOutline} size={1} /> Inicio</>,
                                width: 100
                            },
                            {
                                id: "endTime",
                                cell: (e: any) => <>{e?.jsonSchedule?.endTime !== "" ? e?.jsonSchedule?.endTime : "24:00"}</>,
                                header: <><Icon path={mdiClockOutline} size={1} /> Término</>,
                                width: 100
                            },
                            {
                                id: "medias",
                                cell: (e: any) => e?.jsonMediaSets?.length === 0 ? "" : <Link onClick={() => setMedia(e)}><BadgeCustom color='lime'>{e?.jsonMediaSets?.length}</BadgeCustom></Link>,
                                header: <Icon path={mdiMovieOpenOutline} size={1} />,
                                width: 50
                            },
                            {
                                id: "displays",
                                cell: (e: any) => e?.jsonDisplays?.length === 0 ? "" : <Link onClick={() => setDisplay(e)}><BadgeCustom color='lime'>{e?.jsonDisplays?.length}</BadgeCustom></Link>,
                                header: <Icon path={mdiTelevision} size={1} />,
                                width: 50
                            },
                        ]}
                    />
                    <Modal visible={display} onDismiss={() => setDisplay(null)} closeAriaLabel="Close modal" header="Displays asignados">
                        <List items={display?.jsonDisplays.map((item: any) =>
                            ({ id: item, content: data.displays.find((d: any) => d.idDisplay === item).display })

                        ) || []}
                            renderItem={item => item}
                        />

                    </Modal>
                    <Modal visible={media} onDismiss={() => { setMedia(null); setVideoUrl("") }} closeAriaLabel="Close modal" header="Medias asignadas">
                        <SpaceBetween direction="vertical" size="s" >
                            <List
                                items={media?.jsonMediaSets?.map((item: any) => {
                                    const foundMedia = medias.find((d: any) => d.idMediaSet === item);
                                    return {
                                        id: item,
                                        content: <Link onClick={() => {

                                            setVideoUrl("https://fids-bucket.s3.us-east-1.amazonaws.com/media/videos/" + foundMedia?.hashMediaSet + ".mp4");

                                            //setVideoUrl("https://fids.agunsa.com/routing/api/videos/?L2FwaS9tZWRpYS8xNjE5NDA4eFJZajk3MzVRV25UQS5tcDQ=");
                                        }}>{foundMedia?.fileName || `Archivo no encontrado (${item})`}</Link>
                                    };
                                }) || []}
                                // Access the content property of the object created above
                                renderItem={item => item}
                            />
                            {videoUrl !== "" && (
                                <SpaceBetween direction='vertical' size='xs'>
                                    <VideoPreview apiUrl={videoUrl} />
                                    <Box textAlign="center"><Button variant="normal" onClick={() => { setVideoUrl("") }}>Cerrar Video</Button></Box>
                                </SpaceBetween>
                            )}
                        </SpaceBetween>
                    </Modal>
                </SpaceBetween>
            }
        />
    )
};
